/* src/app/_shared/components/information/information.modal.scss */
.info {
  flex: 1 1 0;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  row-gap: 35px;
  padding: 0 15px;
  height: 80%;
}
.info .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 17px;
}
.info .icon > flw-icon {
  --color: var(--ion-primary-color);
  --size: 35px;
}
.info .icon > flw-icon[color=danger] {
  --color: var(--ion-color-danger);
}
.info .icon > flw-icon[color=dark] {
  --color: var(--color-dark);
}
.info .icon > flw-icon[color=primary] {
  --color: var(--ion-color-primary);
}
.info .icon > flw-icon[color=success] {
  --color: var(--ion-color-success);
}
.info .icon > flw-icon[color=warning] {
  --color: var(--ion-color-warning);
}
.info h3 {
  margin: initial;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  line-height: initial;
}
.info p {
  color: var(--grey-4-color);
  font-family: var(--secondary-font);
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
}
.alert-cosa {
  background-color: red !important;
  height: 1500px;
}
/*# sourceMappingURL=information.modal-4BGMXFI3.css.map */
